interface LineShowInfoProps {
  labeltxt: string;
  valuelable: any;
  valuelablep2?: any;
  icon?: string;
  fontBoldLabel?: boolean;
  currency?: boolean;
  currencyTxt?: string;
}

const LineShowInfo: React.FC<LineShowInfoProps> = ({
  labeltxt,
  valuelable,
  icon,
  currency = false,
  currencyTxt,
  valuelablep2,
  fontBoldLabel,
}) => {
  const formattedValue = parseInt(valuelablep2).toLocaleString("fa-IR");
  return (
    <div className="flex items-center justify-between px-10 py-3 ">
      <label className="flex items-center text-Title/16/Bold text-gray-900 pl-2">
        {" "}
        {labeltxt}{" "}
      </label>

      <div className="flex-grow border-b border-dashed border-gray-600"></div>
      <div className="flex justify-center items-center ">
        <div className={`flex`}>
          <label
            className={
              fontBoldLabel
                ? "text-Title/16/Bold pr-2"
                : "text-Title/16/Bold pr-2"
            }
          >
            {" "}
            {/* {valuelablep2 && formattedValue}{" "} */}
          </label>
          <label className="text-Title/16/Bold pr-2">{valuelable} </label>
          <div className={`${currency ? " " : "hidden"}`}>
            <label className="text-Title/16/Regular text-gray-900 pr-2">
              {currencyTxt}
            </label>
          </div>
        </div>

        {icon ? <img className="mr-2" src={icon} alt="icon" /> : null}
      </div>
    </div>
  );
};
export default LineShowInfo;
